import { User } from "ng/src/app/users/shared/user.model";
import { SystemNotification } from "ng/src/app/notifications/notification.model";

export enum BroadcastChannelTypes {
	SYSTEM_NOTIFICATION = 'systemNotificationChannel'
}
export enum SystemNotificationChannelEvent {
	USER_UPDATED = 'userUpdated',
	RECEIVED_NOTIFICATIONS = 'receivedNotifications'
}

type BroadcastChannelEvents = string | SystemNotificationChannelEvent;

export type BroadcastChannelEvent<EventType extends BroadcastChannelEvents, MessageType = unknown> = {
	key: string
	type: EventType,
	value: MessageType
}

export interface SystemNotificationChannelEventMap extends Record<string, BroadcastChannelEvent<any>> {
	[SystemNotificationChannelEvent.USER_UPDATED]: BroadcastChannelEvent<SystemNotificationChannelEvent.USER_UPDATED, Pick<User, 'dateOfLastDeliveredSystemNotification' | 'dateOfLastViewedSystemNotification'>>,
	[SystemNotificationChannelEvent.RECEIVED_NOTIFICATIONS]: BroadcastChannelEvent<SystemNotificationChannelEvent.RECEIVED_NOTIFICATIONS, SystemNotification[]>
}

export interface BroadcastChannelEventTypeMap {
	[BroadcastChannelTypes.SYSTEM_NOTIFICATION]: SystemNotificationChannelEventMap
}